import * as echarts from "echarts";
import { useEffect, useRef } from "react";
const EchartBar: React.FC<{
  dataOptions: {
    name: string;
    value: number;
  }[];
}> = ({ dataOptions = [] }) => {
  const myRef = useRef<any>();
  useEffect(() => {
    const myChart = echarts.init(myRef.current, undefined, {
      renderer: "canvas",
      useDirtyRect: false,
    });
    let salvProName: any[] = [];
    var salvProValue: any[] = [];
    let max = dataOptions[0].value;
    dataOptions.forEach((item) => {
      salvProName.push(item.name);
      salvProValue.push(item.value);
      max = item.value > max ? item.value : max;
    });
    const salvProMax = new Array(dataOptions.length).fill(max);
    for (let i = 0; i < dataOptions.length; i++) {
      salvProMax.push(salvProValue[0]);
    }
    const option = {
      grid: {
        left: "2%",
        right: "2%",
        bottom: "2%",
        top: "2%",
        containLabel: true,
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "none",
        },
        formatter: function (params: any) {
          return params[0].name + " : " + params[0].value;
        },
      },
      xAxis: {
        show: false,
        type: "value",
      },
      yAxis: [
        {
          type: "category",
          inverse: true,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
            },
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          data: salvProName,
        },
        {
          type: "category",
          inverse: true,
          axisTick: "none",
          axisLine: "none",
          show: true,
          axisLabel: {
            textStyle: {
              color: "#ffffff",
              fontSize: "12",
            },
          },
          data: salvProValue,
        },
      ],
      animationDuration: 15000,
      series: [
        {
          name: "值",
          animationDuration: 15000,
          type: "bar",
          zlevel: 1,
          itemStyle: {
            normal: {
              barBorderRadius: 30,
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                {
                  offset: 0,
                  color: "rgb(57,89,255,1)",
                },
                {
                  offset: 1,
                  color: "rgb(46,200,207,1)",
                },
              ]),
            },
          },
          barWidth: 10,
          data: salvProValue,
        },
        {
          name: "背景",
          type: "bar",
          barWidth: 10,
          barGap: "-100%",
          data: salvProMax,
          itemStyle: {
            normal: {
              color: "rgba(24,31,68,1)",
              // color: "red",
              barBorderRadius: 30,
            },
          },
        },
      ],
    };
    if (option && typeof option === "object") {
      myChart.setOption(option);
    }
    const interValId = setInterval(() => {
      myChart.setOption(option);
    }, 200);
    return () => {
      clearInterval(interValId);
    };
  }, [dataOptions]);
  return (
    <div
      ref={myRef}
      style={{
        height: "80px",
      }}
    ></div>
  );
};
export default EchartBar;
